import {
  LT_FEATURE_FLAG_UPDATE,
  LT_FEATURE_FLAG_UPDATE_AMPLITUDE,
} from '../constants/featureFlag';

import {
  FeatureFlag,
  FF_ENABLE_RCA_V1,
  FF_JOB_DEATAIL_V1,
  FF_LOGS_CATEGORIZATION,
} from 'constants/feature-flags';

const initialState = {
  isLoading: true,
};

function featureFlag(state = initialState, actions) {
  const { type, payload, extra = {} } = actions;
  switch (type) {
    case LT_FEATURE_FLAG_UPDATE: {
      const flags = payload?.data || [];

      const userId = extra?.userId;

      const featureFlags =
        Object.keys(state).length > 1 ? { ...state } : { ...FeatureFlag };

      flags.forEach((key) => {
        if (key === FF_LOGS_CATEGORIZATION) {
          featureFlags[FF_LOGS_CATEGORIZATION] = {
            enabled: true,
            categorizationMap:
              state?.[FF_LOGS_CATEGORIZATION]?.categorizationMap || undefined,
          };
        } else if (key === FF_JOB_DEATAIL_V1) {
          featureFlags[FF_JOB_DEATAIL_V1] = {
            enabled: true,
            disabledFramework: [
              '',
              'tosca',
              'tosca-dex',
              'jmeter',
              'gatling',
              'cypress',
            ],
          };
        } else {
          featureFlags[key] = flags.includes(key);
        }
      });
      localStorage.setItem(
        `featureFlags${userId}`,
        JSON.stringify(featureFlags)
      );

      return {
        ...state,
        isLoading: !state.amplitudeFFFetched,
        normalFFFetched: true,
        ...featureFlags,
      };
    }
    case LT_FEATURE_FLAG_UPDATE_AMPLITUDE: {
      const flags = payload?.result || {};
      const userId = extra?.userId;

      const featureFlags = { ...state, isLoading: false };
      if (flags && typeof flags === 'object') {
        Object.keys(flags).forEach((key) => {
          const isON =
            flags[key]?.variant?.key === 'on' ||
            flags[key]?.variant?.key === 'true';

          featureFlags[key] = isON;
          if (key === FF_LOGS_CATEGORIZATION) {
            const keyMap = flags[key]?.variant?.payload;
            featureFlags[key] = {
              enabled: !['off', 'false']?.includes(flags[key]?.variant?.key),
              categorizationMap: Object.keys(keyMap || {}).map((k) => ({
                name: keyMap[k]?.name || k,
                regex: keyMap[k]?.regex || '',
              })),
            };
            if (featureFlags[key].categorizationMap.length === 0) {
              featureFlags[key].categorizationMap = undefined;
            }
          } else if (key === FF_JOB_DEATAIL_V1) {
            featureFlags[key] = {
              enabled: isON,
              disabledFramework: Object.keys(
                flags[key]?.variant?.payload?.disabled || {}
              ),
            };
          } else if (key === FF_ENABLE_RCA_V1) {
            featureFlags[key] = [
              'manual',
              'first-failure',
              'all-failure',
            ].includes(flags[key]?.variant?.key);
          }
        });
      }

      localStorage.setItem(
        `featureFlags${userId}`,
        JSON.stringify(featureFlags)
      );

      return {
        ...state,
        og: flags,
        isLoading: !state.normalFFFetched,
        amplitudeFFFetched: true,
        ...featureFlags,
      };
    }
    default:
      return state;
  }
}

export default featureFlag;
